const OVERLAY_STATE_KEY = 'b2bProductOverlay';

export const B2B_CLOSE_PRODUCT_OVERLAY_EVENT = 'b2b:close-product-overlay';

/** Wishlist (and lists using product-list--overlay-open) while product take-over is open. */
export function isB2bProductOverlayOpen(): boolean {
    if (typeof document === 'undefined') {
        return false;
    }
    if (document.querySelector('.product-list--overlay-open') !== null) {
        return true;
    }
    return document.querySelector('.take-over--b2b-product.is-showing') !== null;
}

/** Ask the mounted ProductList to close its overlay (same as overlay close button). */
export function requestCloseB2bProductOverlay(): boolean {
    if (!isB2bProductOverlayOpen()) {
        return false;
    }
    window.dispatchEvent(new CustomEvent(B2B_CLOSE_PRODUCT_OVERLAY_EVENT));
    return true;
}

function overlayHistoryState(): Record<string, boolean> {
    return { [OVERLAY_STATE_KEY]: true };
}

export function pushProductOverlayHistory(): void {
    window.history.pushState(overlayHistoryState(), '', window.location.href);
}

export function replaceProductOverlayHistory(): void {
    window.history.replaceState(overlayHistoryState(), '', window.location.href);
}

export function closeProductOverlayHistory(): void {
    window.history.back();
}

export function createProductOverlayPopstateListener(
    isOverlayOpen: () => boolean,
    onPopstateClose: () => void
): () => void {
    const handler = () => {
        if (isOverlayOpen()) {
            onPopstateClose();
        }
    };

    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
}
